/**
 * Key Numbers 5006 — KUK programme key features.
 *
 * The tinted strip under the hero: an icon over one line of copy, repeated
 * across a 2x2 grid below 768px and a single row above it. Ported from
 * kuk-campus-portal's `components/Degree/KeyFeatures.tsx`; see
 * `KeyNumbers5006.tsx` for what v1 hardcodes and what was dropped.
 *
 * Every field maps to a column that already exists on `key_numbers` — the
 * variant adds no schema of its own beyond widening `key_numbers.variant`.
 */

export const KEY_NUMBERS_5006_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Key features",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_icon: "",
    meta_icon_alt: "",
    meta_description: "",
    meta_priority: 1,
    meta_status: true,
  },

  KEY_NUMBERS_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Strip background",
      value: "rgba(159, 28, 51, 0.20)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(159, 28, 51, 0.20)",
      description: "RGBA, not COLOR: the reference tints the strip with its brand colour at 20% and that is defined by its opacity.",
      required: false,
      defaultValue: "rgba(159, 28, 51, 0.20)",
    },
    {
      fieldName: "description_color",
      label: "Feature text colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      required: false,
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "gradient_color_1",
      label: "Icon colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      description: "Applies to icon-key icons; uploaded images keep their own colours.",
      required: false,
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "gradient_color_4",
      label: "Divider colour",
      value: "rgba(159, 28, 51, 0.15)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(159, 28, 51, 0.15)",
      description: "The hairline rules between cells.",
      required: false,
      defaultValue: "rgba(159, 28, 51, 0.15)",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload an icon, or type an icon name",
      description: "Accepts an uploaded image URL OR a built-in icon name such as clock, monitor, givingMoney, books.",
      defaultValue: "",
    },
    {
      header: "Icon alt",
      fieldName: "meta_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Feature text",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 2 Years",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
